import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import { useNavigate } from 'react-router-dom';

import {
  Row,
  Col,
  CardBody,
  Card,
  Label,
  Input,
  Button,
  Table,
} from "reactstrap";
import $ from 'jquery';
import moment from 'moment';
import { Form, Field } from "react-final-form";
import { FaDownload, FaEye } from 'react-icons/fa';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader.js";
import "../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../components/Alerts/alerts.js";
import { Modal, FormGroup, ModalHeader, ModalBody } from "reactstrap";

import CustomerService from "./Customer.service.js";
import AuthService from "../../Authentication/auth.service.js";

import DataTable from 'react-data-table-component';
import { Tooltip } from "@mui/material";

import CreditNotesFilter from "../../../components/Table Filters/InvoiceFilter/creditNotesFilter.js";
import AlertService from "../../../components/Alerts/alerts.js";
import PermissionAccess from '../../../PermissionAccess/Access.js';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import 'jspdf-autotable';




const CreditNotes = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [pdfModalIsOpen, setPDFModalIsOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [filterInvoice_StartDate, setFilterInvoice_StartDate] = useState('');
  const [filterInvoicdue_date, setFilterInvoicdue_date] = useState('');
  const [filterDue_StartDate, setFilterDue_StartDate] = useState('');
  const [filterDudue_date, setFilterDudue_date] = useState('');
  const [search_text, setSearchText] = useState('');
  const [modal, setModal] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedCreditNote, setSelectedCreditNote] = useState(null);

  const handleViewCreditNote = (row) => {
    setSelectedCreditNote(row);
    setIsViewModalOpen(true);
  };

  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
  };


  const [loading, setLoading] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState("");
  const [filterText1, setFilterText1] = useState('');
  const [filterText2, setFilterText2] = useState('');
  const [filterText3, setFilterText3] = useState('');
  const [filterBusiness, setFilterBusiness] = useState('');
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const stored_user = authData.userData

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchCustomers(0, pageLimit);
  }, [pageLimit]);

  function setFilterTextFtn(itemrec, param) {
    //iph todo: 47
    //console.log(itemrec)
    //iph todo: 47
    //console.log('Value of key1:', itemrec);
    if (param === 'users') {
      setFilterText1(itemrec);
    }
    if (param === 'orders') {
      setFilterText2(itemrec);
    }
  };



  const toggleModal = () => {
    setModal(!modal);
  };

  //for search with enter keypress
  function checkenterkey(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  function fetchCustomers(page_index, page_limit, filterText1, filterText2,
    filterInvoice_StartDate, filterInvoicdue_date,
    filterDue_StartDate, filterDudue_date, search_text) {
    var filter = {};
    //iph todo: 47
    //console.log(filterText1);
    if (filterText1) {
      //iph todo: 47
      //console.log("filterText1");
      filter["customer_id"] = filterText1
    }
    if (search_text) {
      //iph todo: 47
      //console.log("search_text");
      filter["search_text"] = search_text
    }
    let business = []
    if (filterBusiness === '') {
      if (stored_user.businesses) {
        business = stored_user.businesses
      }
    } else {
      business.push(filterBusiness);
    }


    if (filterBusiness) {
      //iph todo: 47
      //console.log("filterBusiness");
      filter["filterBusiness"] = filterBusiness
    }
    if (filterText2) {
      //iph todo: 47
      //console.log("filterText1");
      filter["status"] = filterText2
    }
    if (filterDue_StartDate) {
      //iph todo: 47
      //console.log("filterDue_StartDate");
      filter["filterDue_StartDate"] = filterDue_StartDate
    } if (filterDudue_date) {
      //iph todo: 47
      //console.log("filterDudue_date");
      filter["filterDudue_date"] = filterDudue_date
    } if (filterInvoice_StartDate) {
      //iph todo: 47
      //console.log("filterInvoice_StartDate");
      filter["filterInvoice_StartDate"] = filterInvoice_StartDate
    } if (filterInvoicdue_date) {
      filter["filterInvoicdue_date"] = filterInvoicdue_date
    }
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    setLoading(true);

    CustomerService.getAllCreditNotes(authData.sessionID, offset, page_limit, business, filterText1,
      filterText2, filterInvoice_StartDate, filterInvoicdue_date, filterDue_StartDate, filterDudue_date, search_text).then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log("Get Customers response:-", response)
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        }
        else {
          //iph todo: 47
          //console.log(response.data);
          setCustomers(response.data.data);
          setTotalRows(response.data.count.count);
        }
      },
        (error) => {
          setLoading(false);
          const errContent =
            (error.response && error.response.data) || error.message || error.toString();
          //iph todo: 47
          //console.log("Net:-", errContent)
          if (errContent) {
            Alerts.swalErrorAlert(errContent)
          }
          else {
            Alerts.swalErrorAlert(t("Server Error, Please try again later."))
          }
        })
  };
  function handleClear(item) {
    if (item === 'users') {
      $("#colfilter").val('');
      setFilterText1('');
      setFilterBusiness('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'action') {
      // $("#modfilter").val('');
      $("#actfilter").val('');
      setFilterBusiness('');
      setFilterText2('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
    if (item === 'function') {
      $("#funcfilter").val('');
      setFilterText3('');
      setFilterBusiness('');
      setResetPaginationToggle(!resetPaginationToggle);
      var page = 0
      handlePageChange(page++)
    }
  };

  function handlePageChange(page_index) {
    //iph todo: 47
    //console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchCustomers(page_index, pageLimit);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }


  function resetFilters() {
    setResetPaginationToggle(!resetPaginationToggle);
    setFilterText1('');
    setSearchText('');
    setFilterBusiness('');
    setFilterInvoice_StartDate('');
    setFilterInvoicdue_date('');
    setFilterDue_StartDate('');
    setFilterDudue_date('');
    setFilterText2('');
    fetchCustomers(0, pageLimit);

  }

  function searchCustomers() {
    setResetPaginationToggle(!resetPaginationToggle);
    // Filter values
    const filteredText1 = filterText1 || "";
    const filteredText2 = filterText2 || "";
    const FilterInvoice_StartDate1 = filterInvoice_StartDate || "";
    const FilterInvoicdue_date2 = filterInvoicdue_date || "";
    const FilterDue_StartDate3 = filterDue_StartDate || "";
    const Search_text = search_text || "";
    const FilterDudue_date4 = filterDudue_date || "";
    //iph todo: 47
    //console.log(FilterDue_StartDate3)
    //iph todo: 47
    //console.log(FilterDudue_date4)
    fetchCustomers(0, pageLimit, filteredText1, filteredText2, FilterInvoice_StartDate1,
      FilterInvoicdue_date2, FilterDue_StartDate3, FilterDudue_date4, Search_text);
  }

  function filterBussiness() {
    setResetPaginationToggle(!resetPaginationToggle);
    // Filter values
    const filteredText1 = filterText1 || "";
    const filterBusiness = filterBusiness || "";
    const filteredText2 = filterText2 || "";
    const FilterInvoice_StartDate1 = filterInvoice_StartDate || "";
    const FilterInvoicdue_date2 = filterInvoicdue_date || "";
    const FilterDue_StartDate3 = filterDue_StartDate || "";
    const Search_text = search_text || "";
    const FilterDudue_date4 = filterDudue_date || "";
    //iph todo: 47
    //console.log(FilterDue_StartDate3)
    //iph todo: 47
    //console.log(FilterDudue_date4)
    fetchCustomers(0, pageLimit, filteredText1, filteredText2, FilterInvoice_StartDate1,
      FilterInvoicdue_date2, FilterDue_StartDate3, FilterDudue_date4, Search_text);
  }

  const handleInvoicePayments = (row) => {
    if (row.status !== 'paid') {
      row.is_admin = true;
      navigate('/add-payment', { state: { row, check: false } });
    } else {
      AlertService.swalErrorAlert("Invoice Already Paid Successfully")
    }

  }
  function confirmDeleteCustomer(_id, order_no, status) {
    if (status === 'generated') {
      let msg = t("Once deleted, you will not be able to recover this Invoice!")
      Alerts.swalConfirmDeleteAlert(msg).then(res => {
        //iph todo: 47
        //console.log("Resp:-", res)
        if (res === true) {
          sendDelete(_id, order_no)
        }
      })
    } else {
      AlertService.swalErrorAlert("Invoice status should be Generated")
    }
  };

  function sendDelete(id, order_no) {
    setLoading(true);
    CustomerService.deleteInvoice(id, order_no).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Delete customer response:-", response)
      if (response.data.status) {
        fetchCustomers(currentPage, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {

          //iph todo: 47
          //console.log(response);
          setLoading(false);
          Alerts.swalSuccessAlert(t("Invoice Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the customer at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };

  const handleDownloadPDF = (row) => {
    const creditNote = row;
    const content = (
      <div className="credit-note-container">
        <Card className="credit-note-card" id="creditNoteContent">
          <div className="credit-note-header">
            <Row>
              <Col md={8}>
                <img src="/path/to/your/logo.png" alt="" className="company-logo" />
                <h2 className="company-name">IPHRx</h2>
                <p className="company-details">323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</p>
                <p className="company-details">iphrx7@gmail.com</p>
                <p className="company-details">+60 1234567890</p>
              </Col>
              <Col md={4} className="text-end">
                <h1 className="credit-note-title">CREDIT NOTE</h1>
                <table className="credit-note-info-table">
                  <tbody>
                    <tr>
                      <th>Credit Note Number:</th>
                      <td>{creditNote.credit_note_number}</td>
                    </tr>
                    <tr>
                      <th>Date:</th>
                      <td>{moment(creditNote.credit_note_date).format('DD MM YYYY')}</td>
                    </tr>
                    <tr>
                      <th>Status:</th>
                      <td>{creditNote.status}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>

          <div className="credit-note-body">
            <Row>
              <Col md={6}>
                <div className="bill-to-section">
                  <h3 className="section-title">BILL TO</h3>
                  <p className="client-name">{creditNote.user_details?.[0]?.name}</p>
                  <p className="client-details">{creditNote.user_details?.[0]?.email}</p>
                  <p className="client-details">{creditNote.user_details?.[0]?.Address}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="original-invoice-section text-end">
                  <h3 className="section-title">ORIGINAL INVOICE</h3>
                  <p className="invoice-details"><strong>Invoice Number:</strong> {creditNote.invoice_number}</p>
                  <p className="invoice-details"><strong>Order Number:</strong> {creditNote.order_number}</p>
                </div>
              </Col>
            </Row>

            <div className="credit-note-items">
              <Table>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Item Details</th>
                    <th>Batch</th>
                    <th>Returned Quantity</th>
                    <th>Total Quantity</th>
                    <th>Unit Price</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {creditNote.items?.filter(item => item.returned_quantity > 0).map((item, index) => (
                    <tr key={index}>
                      <td>{item.ItemGroup || item.categoryDetails?.Name || ''}</td>
                      <td>
                        <strong>{item.item_name}</strong>
                      </td>
                      <td>{item.selectedBatches?.[0]?.batch_number || '-'}</td>
                      <td>{item.returned_quantity}</td>
                      <td>{item.quantity}</td>
                      <td>RM {parseFloat(item.price).toFixed(2)}</td>
                      <td>RM {(parseFloat(item.price) * parseFloat(item.returned_quantity)).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="credit-note-summary">
              <Row>
                <Col md={8}>
                  <div className="credit-note-notes">
                    <h4>Notes</h4>
                    <p>This credit note is issued for returned items.</p>
                  </div>
                </Col>
                <Col md={4}>
                  <table className="summary-table">
                    <tbody>
                      <tr className="total-row">
                        <th>Total Credit:</th>
                        <td>RM {parseFloat(creditNote.total_amount).toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>
          </div>

          <div className="credit-note-footer">
            <p>If you have any questions about this credit note, please contact us</p>
            <p>Thank you for your business</p>
          </div>
        </Card>
      </div>
    );

    const input = document.createElement('div');
    input.appendChild(content);
    document.body.appendChild(input);

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`CreditNote_${creditNote.credit_note_number}.pdf`);
        document.body.removeChild(input);
      });
  };

  const ViewCreditNoteModal = ({ isOpen, toggle, creditNote }) => {
    if (!creditNote) return null;

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Credit Note Details</ModalHeader>
        <ModalBody>
          <div className="credit-note-container">
            <Card className="credit-note-card" id="creditNoteContent">
              <div className="credit-note-header">
                <Row>
                  <Col md={8}>
                    <img src="/path/to/your/logo.png" alt="" className="company-logo" />
                    <h2 className="company-name">IPHRx</h2>
                    <p className="company-details">323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</p>
                    <p className="company-details">iphrx7@gmail.com</p>
                    <p className="company-details">+60 1234567890</p>
                  </Col>
                  <Col md={4} className="text-end">
                    <h1 className="credit-note-title">CREDIT NOTE</h1>
                    <table className="credit-note-info-table">
                      <tbody>
                        <tr>
                          <th>Credit Note Number:</th>
                          <td>{creditNote.credit_note_number}</td>
                        </tr>
                        <tr>
                          <th>Date:</th>
                          <td>{moment(creditNote.credit_note_date).format('DD MM YYYY')}</td>
                        </tr>
                        <tr>
                          <th>Status:</th>
                          <td>{creditNote.status}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </div>

              <div className="credit-note-body">
                <Row>
                  <Col md={6}>
                    <div className="bill-to-section">
                      <h3 className="section-title">BILL TO</h3>
                      <p className="client-name">{creditNote.user_details?.[0]?.name}</p>
                      <p className="client-details">{creditNote.user_details?.[0]?.email}</p>
                      <p className="client-details">{creditNote.user_details?.[0]?.Address}</p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="original-invoice-section text-end">
                      <h3 className="section-title">ORIGINAL INVOICE</h3>
                      <p className="invoice-details"><strong>Invoice Number:</strong> {creditNote.invoice_number}</p>
                      <p className="invoice-details"><strong>Order Number:</strong> {creditNote.order_number}</p>
                    </div>
                  </Col>
                </Row>

                <div className="credit-note-items">
                  <Table>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Item Details</th>
                        <th>Batch</th>
                        <th>Returned Quantity</th>
                        <th>Total Quantity</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {creditNote.items?.filter(item => item.returned_quantity > 0).map((item, index) => (
                        <tr key={index}>
                          <td>{item.ItemGroup || item.categoryDetails?.Name || ''}</td>
                          <td>
                            <strong>{item.item_name}</strong>
                          </td>
                          <td>{item.selectedBatches?.[0]?.batch_number || '-'}</td>
                          <td>{item.returned_quantity}</td>
                          <td>{item.quantity}</td>
                          <td>RM {parseFloat(item.price).toFixed(2)}</td>
                          <td>RM {(parseFloat(item.price) * parseFloat(item.returned_quantity)).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <div className="credit-note-summary">
                  <Row>
                    <Col md={8}>
                      <div className="credit-note-notes">
                        <h4>Notes</h4>
                        <p>This credit note is issued for returned items.</p>
                      </div>
                    </Col>
                    <Col md={4}>
                      <table className="summary-table">
                        <tbody>
                          <tr className="total-row">
                            <th>Total Credit:</th>
                            <td>RM {parseFloat(creditNote.total_amount).toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="credit-note-footer">
                <p>If you have any questions about this credit note, please contact us</p>
                <p>Thank you for your business</p>
              </div>
            </Card>
          </div>
        </ModalBody>
      </Modal>
    );
  };

  const styles = `
.credit-note-container {
  background-color: #f8f9fa;
  padding: 20px;
}
.credit-note-card {
  background-color: white;
  border: none;
  box-shadow: 0 0 30px rgba(0,0,0,0.1);
  padding: 40px;
  margin-bottom: 20px;
}
.credit-note-header {
  border-bottom: 2px solid #3D607A;
  padding-bottom: 20px;
  margin-bottom: 30px;
}
.company-logo {
  max-width: 200px;
  height: auto;
  margin-bottom: 15px;
}
.company-name {
  color: #3D607A;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
}
.company-details {
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
}
.credit-note-title {
  color: #3D607A;
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 20px 0;
}
.credit-note-info-table {
  width: 100%;
  margin-top: 10px;
}
.credit-note-info-table th, .credit-note-info-table td {
  padding: 1px;
  text-align: right;
}
.credit-note-info-table th {
  color: #3D607A;
  font-weight: 600;
  padding-right: 1px;
}
.credit-note-info-table td {
  padding-left: 1px;
}
.credit-note-body {
  margin-top: 30px;
}
.section-title {
  color: #3D607A;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
}
.client-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}
.client-details, .invoice-details {
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
}
.credit-note-items {
  margin-top: 30px;
  margin-bottom: 30px;
}
.credit-note-items table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.credit-note-items th, .credit-note-items td {
  border: 1px solid #dee2e6;
  padding: 10px;
  text-align: left;
}
.credit-note-items th {
  background-color: #3D607A;
  color: white;
  font-weight: 600;
}
.credit-note-items tr:nth-child(even) {
  background-color: #f8f9fa;
}
.summary-table {
  width: 100%;
}
.summary-table th, .summary-table td {
  padding: 4px;
  text-align: right;
}
.summary-table th {
  color: #3D607A;
  font-weight: 600;
  padding-right: 1px;
}
.summary-table td {
  padding-left: 1px;
}
.total-row {
  font-size: 18px;
  font-weight: 700;
  color: #3D607A;
}
.credit-note-notes {
  background-color: #f8f9fa;
  border-left: 4px solid #3D607A;
  padding: 15px;
}
.credit-note-notes h4 {
  color: #3D607A;
  margin-bottom: 10px;
}
.credit-note-footer {
  margin-top: 40px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}
`



  function SubmitInvoices(_id) {
    var getData = {
      functionName: "SubmitSingleCreditNote",
      postData: {
        invoice_id: _id
      }
    }
    // setLoading(true);
    CustomerService.SubmitSingleInvoices(getData).then((response) => {
      // setLoading(false);
      //iph todo: 47
      //console.log("Get Drivers response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        // window.location.reload();
      }
      else {
        // window.location.reload();
        AlertService.swalSuccessAlert(response.data.message);
      }
      fetchCustomers(currentPage, pageLimit)
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };



  const mycolumns = [
    {
      name: "Date",
      selector: "credit_note_date",
      sortable: true,
      cell: (row) => row?.credit_note_date ? moment(row.credit_note_date).format("DD-MM-YYYY") : '',
    },
    {
      name: "Credit Note Number",
      selector: "credit_note_number",
      sortable: true,
    },

    {
      name: "Customer Name",
      selector: (row) => {
        return <div >{row.user_details ? row?.user_details?.[0]?.[localStorage.getItem('invoice_to_field')] : ''}</div>
      },
      sortable: true,
    },
    {
      name: "Invoice Number",
      selector: (row) => {
        return <div >{row.invoice_details ? row?.invoice_details?.[0]?.invoice_number : ''}</div>
      },
      sortable: true,
    },
    {
      name: "Order Number",
      selector: (row) => {
        return <div >{row.order_details ? row?.order_details?.[0]?.order_number : ''}</div>
      },
      sortable: true,
    },

    {
      name: t('Status'),
      selector: (row) => {
        return (
          <div>
            {row.status === "partial paid" ?
              <button type="button" style={{ borderColor: '#F39026', backgroundColor: '#F39026' }}
                className="btn btn-success btn-hover-shine me-3 btn">{row.status}
              </button>
              :
              row.status === "cancelled" ?
                <button type="button"
                  className="btn btn-danger btn-hover-shine me-3 btn">{row.status}
                </button>
                :
                row.status === "issued" ?
                  <button type="button" style={{ borderColor: '#F39026', backgroundColor: '#1BD35A' }}
                    className="btn btn-c btn-hover-shine me-3 btn">{'Issued'}
                  </button>
                  :
                  row.status === "Adjusted" ?
                    <button type="button"
                      className="btn btn-success btn-hover-shine me-3 btn">{row.status}
                    </button>
                    :
                    row.status === "unpaid" ?
                      <button type="button"
                        className="btn btn-success btn-hover-shine me-3 btn">{row.status}
                      </button>

                      :
                      row.status === "draft" ?
                        <button type="button" style={{ borderColor: '#F39026', backgroundColor: '#F39026' }}
                          className="btn btn-success btn-hover-shine me-3 btn">Draft
                        </button>
                        :
                        <button type="button"
                          className="btn btn-default btn-hover-shine me-3 btn">{row.status}
                        </button>
            }
          </div>
        );
      }
    },
    {
      name: "Total Amount",
      sortable: true,
      selector: (row) => (
        <div >{`${row.currency ? row.currency : ''}${row?.total_amount ? parseFloat(row?.total_amount).toFixed(2) : 0}`} </div>
      )
    },
    {
      name: 'Actions',
      selector: (row) => {
        return (
          <div>
            <button className="mt-2 mb-2 me-2 btn-icon btn">
              {!super_admin ? current_module?.SubmitCreditNote === 1 &&
                row.autoCount_status === "pending" &&
                <Tooltip placement="top" title="Submit Credit Note" arrow>
                  <i onClick={() => SubmitInvoices(row._id)} className="pe-7s-paper-plane text-success btn-icon-wrapper text-info"> </i>
                </Tooltip> : row.autoCount_status === "pending" &&
              <Tooltip placement="top" title="Submit Credit Note" arrow>
                <i onClick={() => SubmitInvoices(row._id)} className="pe-7s-paper-plane text-success btn-icon-wrapper text-info"> </i>
              </Tooltip>
              }
            </button>
          </div>
        );
      }
    },
  ];




  const handlePayments = (row, method) => {
    if (row.status !== 'paid') {
      method.is_admin = true;
      navigate('/add-payment', { state: { row, check: false, method } });
    } else {
      AlertService.swalErrorAlert("Invoice Already Paid Successfully")
    }

  }
  const handleEdit = (row, check) => {
    //iph todo: 47
    //console.log(row);
    if (row.status !== 'paid' && row.status !== 'partial paid') {
      navigate('/update-invoice', {
        state: {
          state: row,
          check: check
        }
      });
    } else {
      AlertService.swalErrorAlert("Paid Invoice isn't Changeable")
    }

  }

  function handleMail(row) {
    let msg = t("Are you sure you want to send Invoice in Email?")
    Alerts.swalConfirmGeneralAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendMail(row)
      }
    })
  };

  function sendMail(row) {
    setLoading(true);
    CustomerService.sendPDF_Mail(row).then((response) => {
      //iph todo: 47
      //console.log("Send mail to:-", response)
      setLoading(false);
      if (response.data.status) {
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Invoice emailed Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't send the Password."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Operation failed"))
      })
  };



  const handleViewPDF = (_id) => {
    var getData = {
      functionName: "Get_PDF_Invoice",
      _id: _id
    };
    setLoading(true);
    //iph todo: 47
    //console.log(getData);
    CustomerService.getInvoice_PDF(authData.sessionID, getData)
      .then((response) => {
        setLoading(false);
        //iph todo: 47
        //console.log(response.status);
        //iph todo: 47
        //console.log(response);
        if (response.status === 200) {
          setPdfUrl(URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' })));
          setPDFModalIsOpen(true);
        } else if (response.status === 401) {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          // Handle other error cases, if necessary
          //iph todo: 47
          //console.log("Response status: " + response.status);
          // Display an error message or perform other actions as needed.
        }
      })
      .catch((error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      });
  };

  const PDFViewerModal = () => {
    //iph todo: 47
    //console.log(pdfUrl);
    return (
      <div
        className={`modal fade ${pdfModalIsOpen ? "show" : ""}`}
        style={{ display: pdfModalIsOpen ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header ">
              <h5 className="modal-title">Customer's Order Invoice</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setPDFModalIsOpen(false)}
              ></button>
            </div>
            <div className="modal-body">
              <iframe title="pdfUrl" src={pdfUrl} style={{ width: "100%", height: "500px" }} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <PDFViewerModal />
      <Fragment>
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className=" bg-light-gray bg-animation ">
              <div className="d-flex  justify-content-center align-items-center">
                <Col md="12" className="mx-auto app-login-box">
                  <div className="app-page-title">
                    <div className="page-title-wrapper">
                      <div className="page-title-heading fw-bold">
                        <div className="page-title-icon">
                          <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                        </div>
                        <div>
                          {t("Credit Notes")}
                          <div className="page-title-subheading">
                            {t('View Details of Credit Notes.')}
                          </div>
                        </div>
                      </div>
                      <div className="page-title-actions">
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                          {t("Back")}
                        </button>
                      </div>
                    </div>
                  </div>
                  <Row>
                    <Fragment>
                      <Row>
                        <Col md="12">
                          <Card className="main-card mb-3">
                            <CardBody>
                              <LoadingOverlay tag="div" active={loading}
                                styles={{ overlay: (base) => ({ ...base }) }}
                                spinner={<DNALoader />}>
                                <ViewCreditNoteModal isOpen={isViewModalOpen} toggle={toggleViewModal} creditNote={selectedCreditNote} />

                                <CreditNotesFilter
                                  super_admin={super_admin}
                                  accessPages={accessPages}
                                  filterBusiness={filterBusiness}
                                  onFilterBusiness={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterBusiness(e.target.value, 'users');
                                  }}
                                  authData={authData}
                                  current_module={current_module}
                                  search_text={search_text}
                                  onSearch_text={(e) => {
                                    setSearchText(e.target.value);
                                  }}

                                  onFilterInvoice_StartDate={setFilterInvoice_StartDate}
                                  onFilterInvoicdue_date={setFilterInvoicdue_date}

                                  onFilterDue_StartDate={setFilterDue_StartDate}
                                  onFilterDudue_date={setFilterDudue_date}



                                  searchCustomers={searchCustomers}
                                  resetFilters={resetFilters}
                                  onFilter1={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterTextFtn(e.target.value, 'users');
                                  }}
                                  onFilter2={(e) => {
                                    //iph todo: 47
                                    //console.log(e.target.value);
                                    setFilterText2(e.target.value, 'users');
                                  }}
                                  handleKeyDown={(event) => checkenterkey(event)}
                                  filterText1={filterText1}
                                  filterText2={filterText2}
                                  filterInvoice_StartDate={filterInvoice_StartDate}
                                  filterInvoicdue_date={filterInvoicdue_date}
                                  filterDue_StartDate={filterDue_StartDate}
                                  filterDudue_date={filterDudue_date}

                                  onClear={() => handleClear('users')}
                                />

                                <DataTable
                                  data={customers}
                                  columns={mycolumns}
                                  pagination
                                  fixedHeader
                                  fixedHeaderScrollHeight="400px"
                                  paginationServer
                                  paginationTotalRows={totalRows}
                                  onChangePage={handlePageChange}
                                  onChangeRowsPerPage={handlePerRowsChange}
                                  paginationResetDefaultPage={resetPaginationToggle}
                                />
                              </LoadingOverlay>

                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </Fragment>
                  </Row>
                </Col>
              </div>
            </div>
          </div>
        </div>

      </Fragment>
    </>

  );
};

export default CreditNotes;